import { css } from '@emotion/css';

export const orbBorder = css`
  position: relative;
  width: 15.2rem;
  height: 7rem;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
      123.21% 421.64% at 93.02% -8.04%,
      rgba(171, 81, 159, 0.55) 0%,
      rgba(250, 163, 32, 0.55) 50%,
      rgba(3, 188, 234, 0.55) 100%
    );
    border-radius: 4.2rem;
    animation: rotate 4s linear infinite;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
      123.21% 421.64% at 93.02% -8.04%,
      rgba(171, 81, 159, 0.55) 0%,
      rgba(250, 163, 32, 0.55) 50%,
      rgba(3, 188, 234, 0.55) 100%
    );
    border-radius: 4.2rem;
    animation: rotate 3s linear infinite;
    opacity: 0.75;
  }

  &:hover::after {
    filter: blur(0.8rem);
  }

  .orb-content {
    position: absolute;
    inset: 0.1rem;
    background: #ffffff;
    border-radius: 4.2rem;
    z-index: 1;
  }
`;

export const orbText = css`
    background: linear-gradient(98.09deg, #303941 6.46%, #AA519E 104.55%);
    -webkit-background-clip: text;
    padding-box text;
    -webkit-text-fill-color: transparent;
`;

export const fs2rem = css`
  font-size: 2rem;
`;

export const height100vh = css`
  height: 100vh;
  max-height: 100vh;
`;
